module.exports = __webpack_public_path__ + "img/cli_08.cec05d30.png";